import { SecureRouteProps, withTcApi } from '../api/tcApiHelper';
import { AddPropsToRoute } from './workflowTab';
import { TAB_NAME } from 'webapp-genric/dist/constants';
import {
  TableSubCategories,
  TableWrapperWithRegion,
} from '../components/tables';
import { Provider } from 'react-redux';
import { store } from '../lib/store';
import { SidebarWrapper } from '../components/common/sideBarWrapper';
import { AppContainer } from './style';
import React from 'react';
import { TableWrapper } from '../components/tables';

const WorkflowsTabV2 = (props: SecureRouteProps) => {
  return (
    <Provider store={store}>
      <AppContainer fluid>
        <SidebarWrapper {...props}>
          <TableWrapperWithRegion
            category={'workflows'}
            tabName={TAB_NAME.WORKFLOWS}
            subCategories={[
              TableSubCategories.TABLE_DATA,
              TableSubCategories.CATEGORY_DATA,
              TableSubCategories.SHARE_SETTINGS_DATA,
            ]}
            {...props}
          />
        </SidebarWrapper>
      </AppContainer>
    </Provider>
  );
};

export default withTcApi(WorkflowsTabV2);
